import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../services/transaksi/TransaksiService'
import { formatDateStringLocalDate, formatDateStringLocalDateINA } from './Utils'

const GetDokumenTanggalEN = ({ nomorAju, idJnsDok }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [nomorDokumen, setNomorDokumen] = useState('')

    useEffect(() => {
        const getNomorDokumen = async () => {
            try {
                const response = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
                setNomorDokumen(response.data.tanggal)
            } catch (error) {
                console.log(error)
                setNomorDokumen('')
            }
        }
        getNomorDokumen()
    }, [transaksiService, nomorAju, idJnsDok])

    return (
        <>
            {nomorDokumen !== '' ? formatDateStringLocalDate(nomorDokumen) : '-'}
        </>
    )

}

export default GetDokumenTanggalEN